var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("nav", { staticClass: "panel" }, [
    _c(
      "p",
      { staticClass: "panel-heading" },
      [
        _c("b-icon", { attrs: { icon: "arrow-left", size: "is-small" } }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "is-pulled-right clear-filters",
            on: { click: _vm.clearFilters },
          },
          [_vm._v(_vm._s(_vm.$t("global.clear")))]
        ),
      ],
      1
    ),
    _c("div", { staticClass: "panel-block" }, [
      _vm._v(
        " " +
          _vm._s(_vm.filteredMarkers.length) +
          " " +
          _vm._s(_vm.$t("customer.map.markers")) +
          " "
      ),
    ]),
    _c("div", { staticClass: "panel-block" }, [
      _c(
        "div",
        { staticClass: "control" },
        [
          _c("label", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("customer.map.types"))),
          ]),
          _vm._l(_vm.types, function (type) {
            return _c(
              "b-field",
              { key: type },
              [
                _c(
                  "b-checkbox",
                  {
                    attrs: { "native-value": type },
                    model: {
                      value: _vm.typeCheckboxGroup,
                      callback: function ($$v) {
                        _vm.typeCheckboxGroup = $$v
                      },
                      expression: "typeCheckboxGroup",
                    },
                  },
                  [_vm._v(" " + _vm._s(type) + " ")]
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
    ]),
    _c("div", { staticClass: "panel-block" }, [
      _c(
        "div",
        { staticClass: "control" },
        [
          _c(
            "b-field",
            { attrs: { label: "Name" } },
            [
              _c(
                "b-autocomplete",
                {
                  attrs: {
                    placeholder: _vm.$t("customer.map.name_placeholder"),
                    data: _vm.filteredMarkers,
                    icon: "search",
                    field: "name",
                  },
                  on: { select: (option) => (_vm.selectedMarker = option) },
                  model: {
                    value: _vm.name,
                    callback: function ($$v) {
                      _vm.name = $$v
                    },
                    expression: "name",
                  },
                },
                [
                  _c("template", { slot: "empty" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("customer.map.no_result")) + " "
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }